import {faDotCircle} from '@fortawesome/pro-solid-svg-icons';
import {ItemIndicator, RadioItem} from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';

import {Icon} from '../Icon/Icon';

import type {DropdownMenuRadioItemProps} from '@radix-ui/react-dropdown-menu';

export function DropdownRadioItem({
  ref: forwardedRef,
  children,
  className,
  ...props
}: DropdownMenuRadioItemProps &
  React.RefAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <RadioItem
      {...props}
      ref={forwardedRef}
      className={clsx(
        className,
        'group relative cursor-pointer py-1 pl-6 pr-2 text-sm radix-disabled:cursor-default radix-disabled:text-slate10 radix-highlighted:bg-blue10 radix-highlighted:font-semibold radix-highlighted:text-white radix-highlighted:outline-hidden radix-state-checked:font-semibold'
      )}
    >
      <ItemIndicator className="absolute left-2 top-1/2 -translate-y-1/2 text-blue11 group-radix-highlighted:text-white">
        <Icon size="2xs" icon={faDotCircle} />
      </ItemIndicator>

      {children}
    </RadioItem>
  );
}

DropdownRadioItem.displayName = 'DropdownRadioItem';
